import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'app-cs-drop-down-toggler-templates',
    templateUrl: './cs-drop-down-toggler-templates.component.html',
    styleUrls: ['cs-drop-down-toggler-templates.component.scss']
})
export class CsDropDownTogglerTemplatesComponent implements OnInit {

    @ViewChild('btnTransparent') btnTransparent: TemplateRef<any>;
    @ViewChild('btnPrimary') btnPrimary: TemplateRef<any>;

    constructor() {
    }

    ngOnInit() {
    }

}
